import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 text-white",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M19 9l-7 7-7-7"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "absolute mt-2 right-0 lg:w-44 md:w-44 w-52 rounded-xl shadow-xl lg:text-sm md:text-sm text-xs overflow-hidden z-20"
}
const _hoisted_4 = {
  class: "rounded-md bg-white shadow-xs w-full px-2 py-1",
  role: "menu",
  "aria-orientation": "vertical",
  "aria-labelledby": "options-menu"
}
const _hoisted_5 = { class: "flex flex-col mt-4" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex flex-row items-center" }
const _hoisted_8 = { class: "font-semibold ml-4 text-black" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "h-0.5 bg-gray-200 mx-4 my-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WarningModal = _resolveComponent("WarningModal")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!
  const _component_ModalRejectCandidate = _resolveComponent("ModalRejectCandidate")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMenuOpen = !_ctx.isMenuOpen)),
        type: "button",
        class: "select-none flex items-center hover:border-primary-light"
      }, _hoisted_2),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-200",
        "enter-class": "transform opacity-0 scale-95",
        "enter-to-class": "transform opacity-100 scale-100",
        "leave-active-class": "transition ease-in duration-75",
        "leave-class": "transform opacity-100 scale-100",
        "leave-to-class": "transform opacity-0 scale-95"
      }, {
        default: _withCtx(() => [
          (_ctx.isMenuOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stages, (item, index) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: `stage-index-${index + 1}`,
                        onClick: ($event: any) => (_ctx.handleWatchStage(item?.job_stage?.stage.name, item.id)),
                        class: "rounded p-1 hover:bg-primary-light"
                      }, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(item?.job_stage?.stage.name), 1),
                          _hoisted_9
                        ])
                      ], 8, _hoisted_6))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 512), [
      [_directive_click_away, _ctx.closeMenu]
    ]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showDrop,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setShowDrop(false))),
      size: "w-1/3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_WarningModal, {
          onCloseModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setShowDrop(false))),
          onEmitAction: _ctx.validateLastStage,
          message: "Are you sure you want to hire the candidate?"
        }, null, 8, ["onEmitAction"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ModalRejectCandidate, {
      showModal: _ctx.showRejected,
      onCloseModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setShowRejected(false))),
      candidateId: _ctx.candidateId,
      stageId: _ctx.lastStage,
      onReloadCandidates: _ctx.reloadCandidates
    }, null, 8, ["showModal", "candidateId", "stageId", "onReloadCandidates"])
  ], 64))
}